import { ComponentProps, useEffect, useState } from 'react'

type Props = ComponentProps<'time'> & {
  dateTime: string
  children: string
  /**
   * 指定された場合、SSR時はこの値が表示される
   */
  ssrFallback?: string
}

/**
 * time要素の薄いラッパーコンポーネント
 *
 * 時刻表示のハイドレーションエラーを防ぐため
 * `ssrFallback` を指定することでSSR時に表示する内容を指定できる
 * （指定しない場合はただのtime要素として振る舞う）
 *
 * 時刻表示のフォーマットは `children` に依存する
 */
export const Time: React.FC<Props> = ({ children, ssrFallback, ...props }) => {
  const [mounted, setMounted] = useState(false)
  useEffect(() => setMounted(true), [])

  const child = ssrFallback === undefined || mounted ? children : ssrFallback

  return <time {...props}>{child}</time>
}
